import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { AppointmentService } from "../../services/Sappointment.service";
import moment from "moment";
import { ReplaySubject, Subject, Subscription, takeUntil } from "rxjs";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { MatTableDataSource } from "@angular/material/table";
import { OPD_CONST } from "../../properties/opd-static-properties";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { removeSpaces } from "../../helper/helper.service";
import { dataObj } from "../../models/MpatientRegistration";
import { MasterUrlService } from "../../services/SmasterUrl.service";
import { DatePipe } from "@angular/common";
import { PatientRegistrationService } from "../../services/Spatient-registration.service";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { MASTERSSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/master-service";
import { PatientService } from "projects/lib/medcare-core-lib/src/lib/services/patient.service";
import { STATICCODESERVICE } from "projects/lib/medcare-core-lib/src/lib/constants/static-code-service";
import { ConfirmDynamicDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/confirm-dynamic-dialog/confirm-dynamic-dialog.component";
import { PatientDTOObject } from "projects/lib/medcare-core-lib/src/lib/core/patient-search/patient-search.component";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { EnvoirnmentService } from "projects/lib/medcare-core-lib/src/lib/services/envoirnment.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { MasterMenus } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
import { MasterKeys } from "projects/lib/medcare-core-lib/src/lib/constants/configuration-modules.constants";
import { ApplicationConfigService } from "projects/lib/medcare-core-lib/src/lib/services/application-config.service";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
@Component({
  selector: "app-add-waiting-list-dialog",
  templateUrl: "./add-waiting-list-dialog.component.html",
  styleUrls: ["./add-waiting-list-dialog.component.scss"],
  providers: [DatePipe],
})
export class AddWaitingListDialogComponent implements OnInit, OnDestroy {
  _onDestroy: Subject<boolean> = new Subject<boolean>();
  private subscriptionList = new Subscription();
  searchList: any[];
  partientSearch: {
    MRN: string;
    PatientName: string;
    identificationType: string;
    identificationNumber: string;
    MobileNo: string;
    birthDate: string;
    patientCategory:string;
    offset: number;
    limit: number;
  };
  offset: number = 0;
  limit: number = 5;
  patientList: any;
  patientData: boolean = false;
  recordsLength: any;
  resultFound: boolean = false;
  dataSource = new MatTableDataSource<any>();
  displayedColumns = OPD_CONST.displaypatientList;
  loadingData: boolean = false;
  patientType: string = "new";
  error: any = { isError: false, errorMessage: "" };
  appointmentForm: FormGroup; 
  defaultGender: dataObj;
  genderValue: any = null;
  primaryValue: any = null;
  prefixValue: any = null;
  base64textString: any;
  imageUser: any;
  masterAPI: any = MASTERSSERVICES;
  showExpirDatePicker: boolean = false;
  isDisabled: boolean = false;
  patientId: string = "";
  selectedPatient: any;
  primaryIdentifierListModified: boolean = false;
  primaryIdList: any[] = [];
  primaryIdRegex: string = "[A-Za-z0-9]*";
  FormRequiredFelds: any = {
    emailRequired: false,
    handphoneRequired: false,
    officeRequired: false,
    homeReqired: false,
    patientRequired: false,
    bookingTypeRequired: false,
    refTypeRequired: false,
    refRequired: false,
    companyRequired: false,
    subSepcilityRequired: false, 
  };
  patientAge: {
    years: string;
    months: string;
    days: string;
  } = {
    years: "0Y",
    months: "0M",
    days: "0Y",
  };
  date = new Date();
  mindate = new Date(1920, 0, 1);
  mobileNoMax: number = 14;
  mobileNoMin: number = 8;
  mobileCodeValue: any = null;
  CountryCode: any = null;
  StateCode: any = null;
  CityCode: any = null;
  countryValue: any = null;
  stateValue: any = null;
  cityValue: any = null;
  districtValue: any = null;
  countryPrimaryList: any[] = [];
  statePrimaryList: any[] = [];
  cityPrimaryList: any[] = [];
  subdistPrimaryList: any[] = [];
  public appointmentTypeList: any = [];
  public filteredappointmentType: ReplaySubject<any[]> = new ReplaySubject<
    any[]
  >(1);
  public appointmentType: any ;
  public appointmentTypeCtrl: FormControl = new FormControl(null, Validators.required);
  departmentList: any[];
  filteredDepts: any;
  public deptCtrl: FormControl = new FormControl(null, Validators.required);
  public doctorCtrl: FormControl = new FormControl(null, Validators.required);
  public deptFilterCtrl: FormControl = new FormControl();
  public docFilterCtrl : FormControl =new FormControl();
  public department: any;
  public filteredTelecom: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public Teleconsultations: any = [];
  public teleconsultaionCtrl: FormControl = new FormControl(null, Validators.required);
  public teleconsultaion: any ;
  doctorFilteredList: any[];
  docList: any[];
  unitCode: string;
  datePreferance: string = "";
  patientInfoDisplay: string = "";
  hidePatientSearch: boolean = false;
  patientImage: any;
  mrn: string;
  patient: PatientDTOObject = new PatientDTOObject();
  isVip:boolean=false;
  prefixCodeList: any;
  refreshTime: string = "";
  searchCriteria: any = null;
  timePreferance: string = "";
  visitTypeList: any;
  patientTypeCat: string = OPD_CONST.aptref.new;
  remark:string="";
  selectedDoctorCode:string;
  genderList: any;
  public dropdownValues: any = {};
  option1Ctrl = new FormControl(null, Validators.required);
  option2Ctrl = new FormControl(null);
  option3Ctrl = new FormControl(null);
  periodFromDateCtrl = new FormControl(null, Validators.required);
  periodToDateCtrl = new FormControl(null, Validators.required);
  isDatePreferanceReq:boolean=false;
  visitType: string="";
  Id: string="";
  isEdit:boolean=false;
  todaysDate: Date = new Date();
  imageUrl: any;
  fromTime: string = '';
  toTime: string = '';
  defaultIdentification: String='';
  primaryIdFilteredList: any;
  primaryIdCode: any=[];
  unitName: string;
  orgCode: string;
  ispatientNameLtwo:boolean=false;
  
  constructor(
    private appoinmentServiceApt: AppointmentService,
    public generalApiServiceapt: GeneralUrlService,
    private langService: MultiLanguageService,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AddWaitingListDialogComponent>,
    private formBuilder: FormBuilder,
    public masterApiServiceapt: MasterUrlService,
    public authService: AuthService,
    public datepipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: AddWaitingListDialogComponent,
    private patientService: PatientService,
    private patientRegService: PatientRegistrationService,
    public baseservice: AppBaseService,
    public dialog:MatDialog,
    public env:EnvoirnmentService,
    private applicationConfigService: ApplicationConfigService,
    private cdr: ChangeDetectorRef
  ) {
    this.getPrimaryIdList()
  }

  ngOnInit(): void {
   this.getUnitData();
   this.searchList= this.appoinmentServiceApt.appoinmentSearchList(this);
    this.imageUrl = this.env.apiUrl;
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
    });
    this.getCountryList();
    this.getAppointmentTypeMaster();
    this.getDepartment();
    this.getTeleApptype();
    this.getPrifixList();
    this.getGenderMaster();
    this.getVisitTypeList();
    this.getDoctorList("");
    this.searchOnChanges();
    if(this.data.patient){
      setTimeout(() => {
      this.getPatient(this.data.patient);
      }, 1000);
    }
    this.deptFilterCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filterDepartmentList();
    });
    this.docFilterCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filterDoctorList();
    });
  }
  ngOnDestroy(): void {
    this.subscriptionList.unsubscribe();
    this._onDestroy.next(true);
    this._onDestroy.complete();
  }
  getUnitData() {
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
      this.unitName = value.unitDescription;
      this.orgCode=value.orgCode;
      this.getOrgAppConfigList();
    });
  }
  /**
   *country list 
   *
   * @memberof AddWaitingListDialogComponent
   */
  getCountryList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_COUNTRY, true)
        .subscribe((data: any) => {
          this.countryPrimaryList = data;
        })
    );
    this.appointmentForm= this.formBuilder.group({
      IdNumber: [null, [removeSpaces]],
      IdType: ["", Validators.required],
      Title: ["", Validators.required],
      FullName: [null, [Validators.required]],
      firstName: [null],
      middleName: [null],
      lastName: [null],
      mfirstName: [null],
      mmiddleName: [null],
      mlastName: [null],
      Gender: [""],
      DOB: ["", Validators.required],
      realdob: [true],
      idExpiry: [""],
      Age: [""],
      Email: [
        "",
        [
          Validators.pattern(
            "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-.]+$"
          ),
        ],
      ],
      countryCodemobile: ["", [Validators.required]],
      HandPhoneNumber: [null, [Validators.required, removeSpaces]],
      OffciePhoneNumber: [""],
      HomePhoneNumber: [""],
      countryPrimary: [""],
      statePrimary: [""],
      cityPrimary: [""],
      subDistrictPrimary: [""],
      pincodePrimary: ["", [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      addressPrimary: [""],
      CompanyType: [""],
      SubSpecility: [""],
      Remarks: [""],
    });
  }
      getOrgAppConfigList() {
        let appConfig: any;
        this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
           this.baseservice
             .getResource("appConfiguration/findConfigByModule?unitCode=null&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
             .pipe(takeUntil(this._onDestroy))
          .subscribe((res) => {
            if (res) {
              appConfig = res.keys;
              appConfig.forEach((element) => {
                if (element.key == MasterKeys.primaryIdentification){
                  if (element.valueList?.length > 0) {
                    let value = this.primaryIdFilteredList.find(i=>i.code == element.valueList[0]?.code)
                      this.primaryValue = value ? value.code : "";
                      this.appointmentForm.controls["IdType"].setValue(this.primaryValue);
                      this.cdr.detectChanges();
                      this.primaryIdentificationOnChange(value)
                }
              }
                if (element.key == MasterKeys.patientNameLtwo) {
                  if (element.valueList.length > 0) {
                    this.ispatientNameLtwo = (element.valueList[0].code == "true") ? true : false;
                    if (this.ispatientNameLtwo) {
                      this.appointmentForm.get('FullName')?.clearValidators();

                      this.appointmentForm.get('firstName')?.setValidators([Validators.required]);
                      this.appointmentForm.get('lastName')?.setValidators([Validators.required]);

                      this.appointmentForm.get('FullName')?.updateValueAndValidity();
                      this.appointmentForm.get('firstName')?.updateValueAndValidity();
                      this.appointmentForm.get('lastName')?.updateValueAndValidity();
                    } else {
                      this.appointmentForm.get('FullName')?.setValidators([Validators.required]);

                      this.appointmentForm.get('firstName')?.clearValidators();
                      this.appointmentForm.get('lastName')?.clearValidators();

                      this.appointmentForm.get('FullName')?.updateValueAndValidity();
                      this.appointmentForm.get('firstName')?.updateValueAndValidity();
                      this.appointmentForm.get('lastName')?.updateValueAndValidity();
                    }
                  }
                }
            });
            } 
          });
      }   

        getPrimaryIdList() {
          this.masterApiServiceapt
            .getTypeMaster(OPD_API_URL.M_IDENTIFICATION)
            .pipe(takeUntil(this._onDestroy))
            .subscribe((data: any) => {
              this.primaryIdFilteredList = data.filter((i) => i.isPrimaryId);
            });
        }
  /**
   *appointment master list
   *
   * @memberof AddWaitingListDialogComponent
   */
  public getAppointmentTypeMaster() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_APPOINTEMENT_TYPE, true)
        .subscribe((data: any) => {
          this.appointmentTypeList = data;
          this.filteredappointmentType.next(this.appointmentTypeList.slice());
        })
    );
  }
  /**
   *gender master 
   *
   * @memberof AddWaitingListDialogComponent
   */
  getGenderMaster() {
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_GENDER,true)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((data: any) => {
          this.genderList = data;
        });
    }
  /**
   *appointment type master list
   *
   * @memberof AddWaitingListDialogComponent
   */
  getTeleApptype() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_TELE_APPOINTMENT_TYPE, true)
        .subscribe((data: any) => {
          this.Teleconsultations = data;
          this.filteredTelecom.next(this.Teleconsultations.slice());
        })
    );
  }
  /**
   *filter department master list 
   *
   * @memberof AddWaitingListDialogComponent
   */
  filterDepartmentList() {
    const searchTerm = this.deptFilterCtrl.value ? this.deptFilterCtrl.value.toLowerCase() : '';
    this.filteredDepts = this.departmentList.filter(department =>
      department.desc.toLowerCase().includes(searchTerm)
    );
  }
  public getDepartment() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_DEPT)
        .subscribe((data) => {
          if (data && data.length > 0) {
            this.departmentList = data;
            this.filteredDepts=data;
          }
        })
    );
  }
/**
 *prifix master list 
 *
 * @memberof AddWaitingListDialogComponent
 */
getPrifixList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_PREFIX)
        .subscribe((data: any) => {
          this.prefixCodeList = data;
        })
    );
  }
  /**
   *visit type list
   *
   * @memberof AddWaitingListDialogComponent
   */
  getVisitTypeList(){
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(this.masterAPI.ENCOUNTER_TYPE_MASTER)
        .subscribe((data: any) => {
          this.visitTypeList = data;
        })
    );
  }
  /**
   *on change method
   *
   * @memberof AddWaitingListDialogComponent
   */
  searchOnChanges() {
    this.subscriptionList.add(
      this.appointmentForm.controls["DOB"].valueChanges.subscribe((res) => {
        var age = this.patientService.calculateAge(res);
        this.patientAge = {
          years: age.years,
          months: age.months,
          days: age.days,
        };
      })
    );
     this.appointmentForm.get('Title')?.valueChanges.subscribe(prefixValue => {
      if (prefixValue == undefined || prefixValue == null) {
        this.appointmentForm.controls["Gender"].enable();
        this.appointmentForm.controls["Gender"].setValue(null);
        this.genderValue = null;
      }
    });
  }
  /**
   *filter doctor master list
   *
   * @memberof AddWaitingListDialogComponent
   */
  filterDoctorList(){
    const searchTerm = this.docFilterCtrl.value ? this.docFilterCtrl.value.toLowerCase() : '';
    this.doctorFilteredList = this.docList.filter(department =>
      department.desc.toLowerCase().includes(searchTerm)
    );
  }
  getDoctorList(departmentCode) {
    let payload = {
      limit: 0,
      unitCode: this.unitCode,
      departmentCode:departmentCode?departmentCode: "",
      typeCodeList: ["DR"],
    };
    this.masterApiServiceapt
      .postTypeMaster(OPD_API_URL.EMPLOYEE_LIST, payload)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        let list = [];
        let letmultilangdoclist = [];
        if (
          data &&
          data.payload &&
          data.payload.employeeResponseList &&
          data.payload.employeeResponseList.length > 0
        ) {
          data.payload.employeeResponseList.forEach((element) => {
            list.push({
              id: element.id,
              code: element.code,
              desc: element.desc,
            });
            letmultilangdoclist.push(element);
          });
        }
        this.doctorFilteredList = list;
        this.docList = data.payload.employeeResponseList;
      });
  }
  selectOnChange(name, value) {
    this.dropdownValues[name] = value.id;
  }
  selectOnClick(control, parent, child) {
    let _this = this;
    try {
      let value = "";
      let hasParam = false;
      if (
        control.url &&
        control.url.includes("{") &&
        control.url.includes("{") &&
        !control.url.includes("{UnitMaster}")
      ) {
        let param = control.url.substring(
          control.url.lastIndexOf("{") + 1,
          control.url.lastIndexOf("}")
        );
        if (this.dropdownValues[param]) {
          control.url = control.url.replace(
            /\{.*?\}/,
            "'" + this.dropdownValues[param].trim() + "'"
          );
        } else {
          control.url = control.url.replace(/\{.*?\}/, "''");
        }
        hasParam = true;
      }
      if (
        !this.searchList[parent].controls[child].options ||
        this.searchList[parent].controls[child].options.length == 0 ||
        hasParam
      ) {
        this.baseservice.setResourceURL("/");
        this.subscriptionList.add(
          this.baseservice.getResource(control.url).subscribe((res) => {
            this.searchList[parent].controls[child].options = res;
            setTimeout(() => {
              document.getElementById(control.name).click();
            }, 500);
          })
        );
      }
    } catch (ex) {}
  }
  /**
   *clear search
   *
   * @memberof AddWaitingListDialogComponent
   */
  clearSearch() {
    this.searchList.forEach((search) => {
      search.controls.forEach((control) => {
        this[control.name] = "";
      });
    });
  }
  /**
   *set search
   *
   * @param {*} data
   * @memberof AddWaitingListDialogComponent
   */
  setSearch(data) {
    let keysArray = Object.keys(data);
    let hasValue = false;

    for (let i = 0; i < keysArray.length; i++) {
      let value = data[keysArray[i]];
      if (value !== "" && value !== null && value !== undefined) {
        hasValue = true;
        break;
      }
    }

    if (hasValue) {
      const birthDate = data.dob
        ? moment(data.dob, "DD/MM/YYYY hh:mm:ss aa").format("YYYY-MM-DD")
        : "";
      this.partientSearch = {
        MRN: data.MRN ? data.MRN : "",
        PatientName: data.PatientName ? data.PatientName : "",
        identificationType: data.identificationType
          ? data.identificationType
          : "",
        identificationNumber: data.identificationNumber
          ? data.identificationNumber
          : "",
        MobileNo: data.MobileNo ? data.MobileNo : "",
        birthDate: birthDate,
        patientCategory: data.patientCategory ? data.patientCategory.code : "",
        offset: this.offset,
        limit: this.limit,
      };
      this.clearSearch();
      var payload = this.appoinmentServiceApt.getSearchPatient(
        this.partientSearch
      );
      this.subscriptionList.add(
        this.generalApiServiceapt
          .getTypeApi(OPD_API_URL.OPD_SERVICE, payload)
          .subscribe((res) => {
            this.patientList = res;
            this.patientData = true;
            this.recordsLength = res.length;
            this.resultFound = true;
            this.displayedColumns = OPD_CONST.displaypatientList;
            const existingData = this.dataSource?.data || [];
            const updatedData = [...existingData, ...res];
            this.dataSource = new MatTableDataSource<any>(updatedData);
            this.loadingData = false;
          })
      );
    } else {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.onesearchparameter"),
        this.langService.get("CommonAppoinment.warning"),
        {
          duration: 3000,
        }
      );
    }
  }
/**
 *patient on select method
 *
 * @param {PatientDTOObject} patient
 * @memberof AddWaitingListDialogComponent
 */
patientOnSelect(patient: PatientDTOObject) {
      this.patient = patient;
      this.patientId = patient.id;
      this.mrn = patient.mrn;
      var dobFormatted = "";
      var patientAge = "";
      if (patient.birthDate) {
        dobFormatted = this.datepipe.transform(patient.birthDate, "dd/MM/yyyy");
      }
      this.patientInfoDisplay =
        patient.mrn +
        " / " +
        patient.fullName +
        " / " +
        (patient.gender ? patient.gender : "Unknown") +
        " / " +
        (patient.birthDate ? dobFormatted + " " + patientAge : "");
      this.patientImage = patient.photo ? patient.photo.url : "";
  
      this.radioClicked1(this.data);
    }
    /**
     *after patient select 
     *
     * @param {*} i
     * @memberof AddWaitingListDialogComponent
     */
    radioClicked1(i) {
      // if(i.isBlocked==false) {
        this.patientData=false;
        this.isVip=i.vip;
      this.isDisabled = true;
      this.resultFound = false;
      this.selectedPatient = i;
      (this.genderValue = i.gender ? i.gender.code : ""),
        (this.primaryValue = i.primaryIdentifier ? i.primaryIdentifier.code : ""),
        (this.prefixValue = i.title ? i.title.code : ""),
        (this.mobileCodeValue = i.mobileNumber ? i.mobileNumber.countryCode : i.countryCode ? i.countryCode : "");
      this.countryValue = i
        ? i.extendedAddress
          ? i.extendedAddress.country.code
          : null
        : null;
        this.defaultGender = i.gender ? i.gender.code : ""
        if (i.title) {
          setTimeout(() => {
          const prefix = this.prefixCodeList.find(item => item.code === i.title.code);
          if (prefix) {
            this.getGender(prefix);
          }
        }, 1000);
        }
        let mrn=i.mrn?i.mrn:i.identifier[0].value
        let name = Array.isArray(i.name) && i.name.length > 0 ? i.name[0].text || i.name[0] : i.name;
        let moNumber = i.mobileNumber ? i.mobileNumber.mobileNumber : (i.telecom && i.telecom[1] ? i.telecom[1].value : null);
      let gender = i.gender.code.toUpperCase();
      const idTypeObj = this.primaryIdFilteredList.find(
        x => x.code === i.primaryIdentifier?.code
      );
      this.appointmentForm.patchValue({
        IdNumber: i.primaryIdentifier ? i.primaryIdentifier.value : "",
        FullName: name,
        Email: i.telecom ? i.telecom[0].value : "",
        HandPhoneNumber: moNumber,
        OffciePhoneNumber: i.telecom ? i.telecom[2].value : "",
        HomePhoneNumber: i.telecom ? i.telecom[3].value : "",
        DOB: new Date(i.birthDate),
        // IdType: {
        //   code: i.primaryIdentifier ? i.primaryIdentifier.code : "",
        //   desc: i.primaryIdentifier ? i.primaryIdentifier.display : "",
        // },
        IdType: idTypeObj,
        idExpiry: i.primaryIdentifier
          ? i.primaryIdentifier.period
            ? new Date(i.primaryIdentifier.period.end)
            : ""
          : "",
        Remarks: "",
        addressPrimary: i.extendedAddress ? i.extendedAddress.addressLine : "",
        pincodePrimary: i.extendedAddress ? i.extendedAddress.postCode : "",
        realdob:true,
        firstName: i.firstName ?? '',
        middleName: i.middleName ?? '',
        lastName: i.lastName ?? '',
        mfirstName: i.mfirstName ?? '',
        mmiddleName: i.mmiddleName ?? '',
        mlastName: i.mlastName ?? ''
      });
      this.getStatePrimaryList(
        i.extendedAddress && i.extendedAddress.country
          ? i.extendedAddress.country.code
          : "",
        true
      );
      var dobFormatted = "";
      var patientAge = "";
      if (i.birthDate) {
        dobFormatted = this.datepipe.transform(i.birthDate, "dd/MM/yyyy");
      }
      this.patientInfoDisplay =
        mrn +
        " / " +
        name +
        " / " +
        (gender ? gender : "UNKNOWN") +
        " / " +
        (i.birthDate ? dobFormatted : " ") +
        " (" +
        (this.patientAge ? this.patientAge.years : "") +
        ")";
        this.imageUser= i.photo ? i.photo[0].url : "";
    // }else{
    //   this.snackBar.open(
    //     this.langService.get("CommonAppoinment.alreadyBlocked"),
    //     this.langService.get("CommonAppoinment.warning"),
    //     {
    //     duration: 3000,
    //   });
    // }
    this.dataSource = new MatTableDataSource<any>([]);
    }
  searchByMRN(event) {
    let result = { MRN: event.target.value };
    this.setSearch(result);
  }
  closeDialog() {
    this.dialogRef.close();
  }
  /**
   *get patient for edit
   *
   * @param {*} element
   * @return {*}  {void}
   * @memberof AddWaitingListDialogComponent
   */
  getPatient(element: any): void {
    const form = this.appointmentForm.controls;
    const patientData =element.patient?element.patient: element.temporaryPatient?element.temporaryPatient:null;
    this.Id=element.id?element.id:'';
    this.isEdit=element.id?true:false;
    if(this.Id) this.appointmentForm.disable();
    let photo = element.temporaryPatient?.photo ? element.temporaryPatient?.photo : "";
    // if( photo && photo.includes("doc-service")) photo=this.imageUrl+ photo;

    this.imageUser=photo.url;
    if (!patientData) return;
    
    this.selectedPatient = patientData;
    
    if (element.patientType?.code === OPD_CONST.aptpatientTypeTemp.code) {
      const primaryIdType = patientData.primaryIdentificationType?patientData.primaryIdentificationType[0]:patientData.primaryIdentifier?patientData.primaryIdentifier:null;
      this.primaryValue = primaryIdType?.code || "";
      this.primaryIdentificationOnChange(primaryIdType);
      
      this.prefixValue = patientData.title?.code || '';
      this.genderValue = patientData.gender?.code || '';
      this.mobileCodeValue = patientData.countryCode?.code ||patientData.countryCode|| '';
      
      const country = patientData.extendedAddress?.country;
      this.countryValue = country?.code || '';
      if (country?.code) {
        this.getStatePrimaryList(country.code, true);
      }
      
      this.stateValue = patientData.extendedAddress?.state?.code || '';
      
      form["IdNumber"].patchValue(patientData.idNumber || "");
      form["FullName"].patchValue(patientData.patientName || "");
      form["Email"].patchValue(patientData.email || "");
      form["HandPhoneNumber"].patchValue(patientData.mobileNumber || "");
      form["OffciePhoneNumber"].patchValue(patientData.officeNo || "");
      form["HomePhoneNumber"].patchValue(patientData.homeNo || "");
      form["DOB"].patchValue(patientData.birthDate ? new Date(patientData.birthDate) : null);
      form["idExpiry"].patchValue(patientData.idExpiry ? new Date(patientData.idExpiry) : null);
      form["Remarks"].patchValue(element.remarks || "");
      form["addressPrimary"].patchValue(patientData.extendedAddress?.addressLine || "");
      form["pincodePrimary"].patchValue(patientData.extendedAddress?.postCode || "");
      form["realdob"].patchValue(element.isReal || false);
      form["firstName"].patchValue(patientData?.firstName || "");
      form["middleName"].patchValue(patientData?.middleName || "");
      form["lastName"].patchValue(patientData?.lastName || "");
      form["mfirstName"].patchValue(patientData?.mfirstName || "");
      form["mmiddleName"].patchValue(patientData?.mmiddleName || "");
      form["mlastName"].patchValue(patientData?.mlastName || "");
    }else{
      this.patientType="registered";
      this.radioClicked1(this.selectedPatient);
    }
    this.appointmentType = element.serviceCategory?.code || '';
    this.onAppointmentChange(this.appointmentType);
    this.department = element.specialty?.[0]?.coding?.[0]?.code || '';
    this.getDoctorList(this.department);
    this.teleconsultaion = element.consultationType?.code || '';
    this.selectedDoctorCode = element.doctor?.code || '';
    this.datePreferance=element.isPeriod?OPD_CONST.aptref.period :OPD_CONST.aptref.speDate ;
    if (element.specificDateList && element.specificDateList.length > 0) {
      this.option1Ctrl.setValue(element.specificDateList[0] ? new Date(element.specificDateList[0] * 1000) : null);
      this.option2Ctrl.setValue(element.specificDateList[1] ? new Date(element.specificDateList[1] * 1000) : null);
      this.option3Ctrl.setValue(element.specificDateList[2] ? new Date(element.specificDateList[2] * 1000) : null);
    }
    this.remark=element.remarks?element.remarks:'';
    this.visitType = element.visitType ? element.visitType.code : '';
    this.periodFromDateCtrl.setValue(new Date(element.expectedStartDateTime * 1000));
    this.periodToDateCtrl.setValue(new Date(element.expectedEndDateTime * 1000));
    this.timePreferance = ( element.timePrefFormTime &&  element.timePrefToTime ) ? OPD_CONST.aptref.timePeriod : OPD_CONST.aptref.anyTime;
    this.fromTime = element.timePrefFormTime ? element.timePrefFormTime : '';
    this.toTime = element.timePrefToTime ? element.timePrefToTime : '';

}



  handleFileSelect(evt) {
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    this.imageUser = OPD_CONST.appoinmentRef.imageData + this.base64textString;
  }
  selectFile() {
    document.getElementById(OPD_CONST.appoinmentRef.fileAttachment).click();
  }
  /**
   *get gender on prifix
   *
   * @param {*} prefixvalue
   * @memberof AddWaitingListDialogComponent
   */
  getGender(prefixvalue) {
    if(!this.genderValue){
    let formRegistration = this.appointmentForm.controls;
    let res =
      prefixvalue && prefixvalue.genderMaster
        ? prefixvalue.genderMaster.code
        : "";
    if (res) {
      this.genderValue = res;
      formRegistration["Gender"].disable();
    } else {
      this.genderValue = this.defaultGender
        ? this.defaultGender
        : this.genderValue;
      formRegistration["Gender"].enable();
    }
  }
  }
  /**
   *validation on primary number 
   *
   * @param {string} value
   * @memberof AddWaitingListDialogComponent
   */
  idFocusOut(value: string) {
    this.validationOnPrimarynumber(value);
    if (this.patientId) {
      if (this.selectedPatient.id) this.primaryIdentifierListModified = true;
    }

    let primaryIdCode = this.appointmentForm.controls["IdType"].value;
    if (primaryIdCode) {
      if (primaryIdCode.isMyKad && value.length < 14)
        this.appointmentForm.controls["IdNumber"].setErrors({
          incorrect: true,
        });
    }
  }
  validationOnPrimarynumber(value: string) {
    if (this.patientId == "" && value.length > 0) {
      let primaryIdCode = this.appointmentForm.controls["IdType"].value;
      if (primaryIdCode) {
        this.generalApiServiceapt
          .getTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_DUPLICATE +
              primaryIdCode.code +
              "&value=" +
              value.replace(/-/g, "")
          )
          .pipe(takeUntil(this._onDestroy))
          .subscribe((res) => {
            if (res != null) {
              this.appointmentForm.controls["IdNumber"].setValue("");
            }
          });
      }
    }
  }
  primaryNumberOnKeyUp(value: string) {
    try {
      let primaryIdCode = this.appointmentForm.value.IdType;
      value = value.replace(/\s/g, "");
      this.appointmentForm.controls["IdNumber"].setValue(value);
  
      if (primaryIdCode) {
        if (primaryIdCode == OPD_CONST.idTypemykadValue) {}
  
        let primaryIdentify = this.primaryIdList.find(
          (i) => i.code == primaryIdCode.code
        );
  
        if (primaryIdCode.isMyKad) {
          var r = /(\D+)/g,
            npa = "",
            nxx = "",
            last4 = "";
          value = value.replace(r, "");
          var c: string = value;
          npa = value.substr(0, 6);
          nxx = value.substr(6, 2);
          last4 = value.substr(8, 4);
          value = npa + "-" + nxx + "-" + last4;
          this.appointmentForm.controls["IdNumber"].setValue(value ? value : "");
          this.primaryIdRegex = "^[0-9 -]+$";
        }
  
        if (value.length >= 12 && primaryIdCode.isMyKad) {
          const array = Array.from(c);
          const yearSuffix = parseInt(array[0] + array[1], 10);
          const cal_month = parseInt(array[2] + array[3], 10);
          const cal_day = parseInt(array[4] + array[5], 10);
          const genderDigit = parseInt(array[11], 10);
  
          // Gender Determination
          let genderVal =
            genderDigit % 2 === 0
              ? STATICCODESERVICE.GENDER_MASTER_FEMALE
              : STATICCODESERVICE.GENDER_MASTER_MALE;
          this.genderValue = this.patientRegService.getCodeByStaticCode(
            this.genderList,
            genderVal
          );
  
          if (yearSuffix >= 30 && yearSuffix <= 99) {
            const yr = 1900 + yearSuffix;
            this.appointmentForm.controls["DOB"].setValue(
              new Date(yr, cal_month - 1, cal_day)
            );
            this.appointmentForm.controls["realdob"].setValue(true);
          } else if (yearSuffix >= 0 && yearSuffix <= 29) {
            const yr = 2000 + yearSuffix;
            var currentYear = new Date().getFullYear();
            if (yr > currentYear) {
              this.snackBar.open(
                this.langService.get("CommonAppoinment.FutureAgeMessage"),
                this.langService.get("CommonAppoinment.warning"),
                { duration: 10000 }
              );
              this.appointmentForm.controls["DOB"].setValue("");
            } else {
              this.appointmentForm.controls["DOB"].setValue(
                new Date(yr, cal_month - 1, cal_day)
              );
            }
          }
        }
      }
    } catch (ex) {}
  }
  
  /**
   *validation on identification change 
   *
   * @param {*} idTypeCode
   * @memberof AddWaitingListDialogComponent
   */
  primaryIdentificationOnChange(idTypeCode: any) {
    let appointmentForm = this.appointmentForm.controls;
    if(!this.isEdit){ appointmentForm["IdNumber"].setValue("");}
   
    if (idTypeCode.value) {
      this.primaryIdCode = this.primaryIdFilteredList.find(
        (s) => s.code == idTypeCode.value
      );
    }else{
        this.primaryIdCode = this.primaryIdFilteredList.find(
          (s) => s.code == idTypeCode.code
        );
      }
      
      if (this.primaryIdCode) {
        if (this.primaryIdCode.isMyKad == true) {
          this.primaryIdRegex = "^[0-9 -]+$";
        } else {
          this.primaryIdRegex = this.primaryIdCode.validation
            ? this.primaryIdCode.validation
            : "";
        }
      }
      // if (!this.selectedPatient) {
        if (this.primaryIdCode?.code == OPD_CONST.idTypePassportValue) {
          appointmentForm["idExpiry"].setValue("");
          appointmentForm["idExpiry"].enable();
          this.showExpirDatePicker = true;
        } else {
          appointmentForm["idExpiry"].setValue("");
          appointmentForm["idExpiry"].disable();

          this.showExpirDatePicker = false;
        }
        this.primaryNumberOnKeyUp(appointmentForm["IdNumber"].value);
      // }
  }
  /**
   *mobile number regex validation 
   *
   * @param {*} event
   * @memberof AddWaitingListDialogComponent
   */
  setPatternToMobileNumber(event) {
    if (event.regex) {
      const regexPattern = event.regex.replace(/^\/|\/$/g, "");
      this.appointmentForm.controls["HomePhoneNumber"].setValidators([
        Validators.pattern(new RegExp(regexPattern)),
      ]);
      const matches = event.regex.toString().match(/\{(\d+),(\d+)\}/);
      if (matches && matches.length > 1) {
        this.mobileNoMax = Number(matches[2]);
        this.mobileNoMin = Number(matches[1]);
      }
    } else {
      this.appointmentForm.controls["HomePhoneNumber"].markAsTouched();
    }
    this.appointmentForm.controls["HomePhoneNumber"].updateValueAndValidity();
  }
  public patientTypeChange(value) {
    this.appointmentForm.reset();
    this.patientTypeCat = value;
    this.patientInfoDisplay = "";
    this.patientType = value;
  }
  timePreferanceChange($event) {
    this.timePreferance = $event.value;
  }
  public datePreferanceChange($event) {
    this.datePreferance = $event.value;
    this.isDatePreferanceReq=false;
    if($event.value==OPD_CONST.aptref.speDate){
      this.periodFromDateCtrl.reset();
      this.periodToDateCtrl.reset();
    }else{
      this.option1Ctrl.reset();
      this.option2Ctrl.reset();
      this.option3Ctrl.reset();
    }
  }
  /**
   *get states
   *
   * @param {*} countryCode
   * @param {*} isCode
   * @memberof AddWaitingListDialogComponent
   */
  getStatePrimaryList(countryCode, isCode) {
    if (countryCode) {
      let result: any = "";
      if (isCode)
        result = this.countryPrimaryList.find((i) => i.code == countryCode);
      else
        result = this.countryPrimaryList.find(
          (i) => i.code == countryCode.code
        );
      this.CountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + result.id
          )
          .subscribe((res) => {
            this.statePrimaryList = res;
            if (this.selectedPatient) {
              const stateres = this.statePrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress
                      ?  this.selectedPatient.extendedAddress.state.code
                    : "")
              );
              this.stateValue = stateres ? stateres.code : "";
              this.getCityPrimaryList(stateres);
            }
          })
      );
    }
  }
  getCityPrimaryList(stateCode) {
    if (stateCode) {
      const result = this.statePrimaryList.find(
        (i) => i.code == stateCode.code
      );
      this.StateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + result.id
          )
          .subscribe((res) => {
            this.cityPrimaryList = res;
            if (this.selectedPatient) {
              const cityres = this.cityPrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress ? this.selectedPatient.extendedAddress.city.code
                    : "")
              );
              this.cityValue = cityres ? cityres.code : "";
              this.getSubDistrictPrimaryList(cityres);
            }
          })
      );
    }
  }

  getSubDistrictPrimaryList(cityCode) {
    if (cityCode) {
      const result = this.cityPrimaryList.find((i) => i.code == cityCode.code);
      this.CityCode = {
        field: OPD_API_URL.M_CITY_VALUE,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + result.id
          )
          .subscribe((res) => {
            this.subdistPrimaryList = res;

            if (this.selectedPatient) {
              const distres = this.subdistPrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress
                      ? this.selectedPatient.extendedAddress.area.code
                      : this.selectedPatient.extendedAddress.area)
              );
              this.districtValue = distres ? distres.code : "";
            }
          })
      );
    }
  }
  /**
   *search teble scroll
   *
   * @param {*} e
   * @memberof AddWaitingListDialogComponent
   */
  onTableScroll(e) {
    const tableViewHeight = e.target.offsetHeight; // viewport
    const tableScrollHeight = e.target.scrollHeight; // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled
    const buffer = 500;
    const limit = tableScrollHeight - tableViewHeight - buffer;

    if (scrollLocation > limit && !this.loadingData) {
      this.loadingData = true; 
      this.offset += 1;
      this.setSearch(this.partientSearch);
    }
}
/**
 *validation on save
 *
 * @memberof AddWaitingListDialogComponent
 */
validationOnSave() {
  if(this.Id){
    this.appointmentForm.enable();
  }
 
  if (!this.appointmentForm.valid || 
      !this.appointmentTypeCtrl.valid || 
      !this.teleconsultaionCtrl.valid || 
      !this.doctorCtrl.valid || this.datePreferance=="") {
    this.markAllFieldsAsTouched([
      this.appointmentTypeCtrl, 
      this.deptCtrl, 
      this.teleconsultaionCtrl, 
      this.doctorCtrl
    ]);
    this.appointmentForm.markAllAsTouched();
    this.isDatePreferanceReq=true;
    if(this.isEdit){this.appointmentForm.disable();}
    this.snackBar.open("Please fill Mandatory fields", "Validation", { duration: 2000 });
  } else if (this.datePreferance === OPD_CONST.aptref.speDate && 
             (!this.option1Ctrl.valid)) {
    this.markAllFieldsAsTouched([this.option1Ctrl, this.option2Ctrl, this.option3Ctrl]);
    this.appointmentForm.disable();
    this.snackBar.open("Please add Specific Dates", "Validation", { duration: 2000 });
  } else if (this.datePreferance === OPD_CONST.aptref.period && 
             (!this.periodFromDateCtrl.valid || !this.periodToDateCtrl.valid)) {
    this.markAllFieldsAsTouched([this.periodFromDateCtrl, this.periodToDateCtrl]);
    this.appointmentForm.disable();
    this.snackBar.open("Please add Dates", "Validation", { duration: 2000 });
  } else {

       const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
              width: "20pc",
              data: { displayText: "doyouwanttoproceed" },
            });
            this.subscriptionList.add(
              dialogRef.afterClosed().subscribe((result) => {
                if (result.confirm == "yes") {
                  if(this.Id){
                    this.updateAppointment();
                  }else{
                    this.saveAppointment();
                  }
                }else{
                  if(this.Id) this.appointmentForm.enable();
                }
              })
            );
  
  }
}

// Helper method to mark fields as touched
markAllFieldsAsTouched(fields: any[]) {
  fields.forEach(field => field.markAsTouched());
}
/**
 *save waiting list
 *
 * @memberof AddWaitingListDialogComponent
 */
saveAppointment() {
  let form = this.appointmentForm.value;
  let countryCode = {
    code: form.countryCodemobile
      ? form.countryCodemobile.code
      : "",
    display: form.countryCodemobile
      ? form.countryCodemobile.desc
      : "",
    system: OPD_CONST.aptpatientType.system,
  };

  var patCat: any = {};
    var patient: any = {};
    if (this.patientTypeCat == OPD_CONST.aptpatientType.desc) {
      patCat = {
        code: OPD_CONST.aptpatientType.code,
        display: OPD_CONST.aptpatientType.desc,
        system: OPD_CONST.aptpatientType.system,
      };
      patient = {
        code: this.selectedPatient.mrn,
        display: this.selectedPatient.id,
        system: OPD_CONST.appoinmentRef.extendedPatient,
      };
    } else {
      patCat = {
        code: OPD_CONST.aptpatientTypeTemp.code,
        display: OPD_CONST.aptpatientTypeTemp.desc,
        system: OPD_CONST.aptpatientTypeTemp.system,
      };
      patient = {
        code: "",
        display: "",
        system: "",
      };
    }
    let specialityObj = this.departmentList.find(
      (i) => i.code == this.deptCtrl.value
    );
    let aptTypeValue = this.appointmentTypeList.find(
      (i) => i.code == this.appointmentType
    );
    var apttype = {
      code: aptTypeValue.code,
      display: aptTypeValue.desc,
      system: OPD_CONST.aptpatientType.system,
    };
    let consultationTypeobj=this.Teleconsultations.find(
      (i) => i.code == this.teleconsultaion
    )
    var consultationType = {
      code: consultationTypeobj ? consultationTypeobj.code : "",
      display: consultationTypeobj ? consultationTypeobj.desc : "",
      system: OPD_CONST.aptpatientType.system,
    };
    let docObj=this.docList.find(
      (i) => i.code ==  this.selectedDoctorCode
    )
let visitTypeObj= this.visitTypeList.find(
  (i) => i.code == this.visitType
);
let visitType = {
  code: visitTypeObj ? visitTypeObj.code : "",
  display: visitTypeObj ? visitTypeObj.desc : "",
  system: OPD_CONST.aptpatientType.system,
};
  let payload={
  idTypeList: this.langService.createObjectList(form.IdType),
  idNumber: form.IdNumber,
  idExpiry: form.idExpiry ? form.idExpiry._d : "",
  titleList: this.langService.createObjectList(form.Title),
  patientName:form.FullName,
  photo: {
      contentType: "image/jpeg",
      url:  this.imageUser,
  },
  genderList: this.langService.createObjectList(this.appointmentForm.controls["Gender"].value),
  dob: new Date(form.DOB).toISOString(),
  email: form.Email,
  countryCode:countryCode,
  mobileNo: form.HandPhoneNumber,
  officeNo: form.OffciePhoneNumber,
  homeNo: form.HomePhoneNumber,
  patientType: patCat,
  patient: patient,
  remarks: this.remark,
  specialityList: this.langService.createObjectList(specialityObj),
  doctorList: this.langService.createObjectList(docObj),
  serviceList:this.langService.createObjectList(aptTypeValue),
  serviceCategory: apttype,
  appointmentType: apttype,
  consultationType:consultationType,
  isReal: form.realdob,
  extendedAddress: {
    countryList: this.langService.createObjectList(
      form.countryPrimary
    ),
    cityList: this.langService.createObjectList(
      form.cityPrimary
    ),
    stateList: this.langService.createObjectList(
      form.statePrimary
    ),
    areaList: this.langService.createObjectList(
      form.subDistrictPrimary
    ),
    postCode: form.pincodePrimary ? form.pincodePrimary : null,
    addressLine: form.addressPrimary
      ? form.addressPrimary
      : null,
  },
  "specialRequirements": [],
  "trn": "",
  "packageList": [],
  expectedStartDateTime:  this.periodFromDateCtrl.value ? Math.floor(new Date(this.periodFromDateCtrl.value).getTime() / 1000) : null,
  expectedEndDateTime: this.periodToDateCtrl.value ? Math.floor(new Date(this.periodToDateCtrl.value).getTime() / 1000) : null,
  specificDates: this.option1Ctrl.value
  ? [
      Math.floor(new Date(this.option1Ctrl.value).getTime() / 1000),
      this.option2Ctrl.value ? Math.floor(new Date(this.option2Ctrl.value).getTime() / 1000) : null,
      this.option3Ctrl.value ? Math.floor(new Date(this.option3Ctrl.value).getTime() / 1000) : null
    ].filter(date => date !== null) 
  : [],
  isPeriod: this.datePreferance==OPD_CONST.aptref.period?true:false,
  visitType: visitType,
  timePrefFormTime:this.fromTime,
  timePrefToTime:this.toTime,
    firstName: form.firstName,
    middleName: form.middleName,
    lastName: form.lastName,

    mfirstName: form.mfirstName,
    mmiddleName: form.mmiddleName,
    mlastName: form.mlastName,
  }
  this.subscriptionList.add(
    this.generalApiServiceapt
      .postTypeApi(OPD_API_URL.OPD_SERVICE,OPD_API_URL.WAITING_LIST_SAVE, payload)
      .subscribe((res:any) => {
      if(res.appointment){
        this.snackBar.open(
          this.langService.get("CommonAppoinment.successfullycreated"),
          this.langService.get("CommonAppoinment.success"),
          {
            duration: 2000,
          }
        );
        this.dialogRef.close();
      }
      })
  );

}
/**
 *update waiting appointment 
 *
 * @memberof AddWaitingListDialogComponent
 */
updateAppointment(){
  let specialityObj = this.departmentList.find(
    (i) => i.code == this.deptCtrl.value
  );
  let docObj=this.docList.find(
    (i) => i.code ==  this.selectedDoctorCode
  );
  let aptTypeValue = this.appointmentTypeList.find(
    (i) => i.code == this.appointmentType
  );
  var apttype = {
    code: aptTypeValue.code,
    display: aptTypeValue.desc,
    system: OPD_CONST.aptpatientType.system,
  };
  let consultationTypeobj=this.Teleconsultations.find(
    (i) => i.code == this.teleconsultaion
  )
  var consultationType = {
    code: consultationTypeobj ? consultationTypeobj.code : "",
    display: consultationTypeobj ? consultationTypeobj.desc : "",
    system: OPD_CONST.aptpatientType.system,
  };
  let visitTypeObj= this.visitTypeList.find(
    (i) => i.code == this.visitType
  );
  let visitType = {
    code: visitTypeObj ? visitTypeObj.code : "",
    display: visitTypeObj ? visitTypeObj.desc : "",
    system: OPD_CONST.aptpatientType.system,
  };
  let Payload = {
    id:this.Id,
    remarks: this.remark,
    specialityList: this.langService.createObjectList(specialityObj),
    doctorList:this.langService.createObjectList(docObj),
    appointmentType: apttype,
    consultationType:consultationType,
    expectedStartDateTime:  this.periodFromDateCtrl.value ? Math.floor(new Date(this.periodFromDateCtrl.value).getTime() / 1000) : null,
    expectedEndDateTime: this.periodToDateCtrl.value ? Math.floor(new Date(this.periodToDateCtrl.value).getTime() / 1000) : null,
    specificDates: this.option1Ctrl.value
    ? [
        Math.floor(new Date(this.option1Ctrl.value).getTime() / 1000),
        this.option2Ctrl.value ? Math.floor(new Date(this.option2Ctrl.value).getTime() / 1000) : null,
        this.option3Ctrl.value ? Math.floor(new Date(this.option3Ctrl.value).getTime() / 1000) : null
      ].filter(date => date !== null) 
    : [],  
  isPeriod: this.datePreferance==OPD_CONST.aptref.period?true:false,
  visitType: visitType,
  timePrefFormTime:this.fromTime,
  timePrefToTime:this.toTime,
  
}
this.subscriptionList.add(
  this.generalApiServiceapt
    .patchTypeApi(OPD_API_URL.OPD_SERVICE,OPD_API_URL.WAITING_LIST_UPDATE, Payload)
    .subscribe((res:any) => {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.successfullycreated"),
        this.langService.get("CommonAppoinment.success"),
        {
          duration: 2000,
        }
      );
      this.dialogRef.close();
    })
);

}
getObjByCode(list: any[], code: string): string {
  let value;
  if (list && list.length > 0) {
    value = list.find((i) => i.code == code);
  }
  return value;
}
/**
 *on appointment change 
 *
 * @param {*} value
 * @memberof AddWaitingListDialogComponent
 */
onAppointmentChange(value){
  if(value==OPD_CONST.aptref.apttTypeHscCode){
    this.department=OPD_CONST.aptref.apttTypeHscDesc;
    this.deptCtrl.disable();
  this.doctorCtrl.clearValidators();
  this.doctorCtrl.updateValueAndValidity();
  }else if(value==OPD_CONST.aptref.apttypeDeptCode){
    this.department="";
    this.deptCtrl.enable();
    this.doctorCtrl.clearValidators();
    this.doctorCtrl.updateValueAndValidity();
  }else{
    this.department="";
    this.deptCtrl.enable();
    this.doctorCtrl.setValidators(Validators.required);
    this.doctorCtrl.updateValueAndValidity();
  }
}
get minToDate(): Date {
  return this.periodFromDateCtrl.value ? this.periodFromDateCtrl.value : this.todaysDate;
}
}
